export default "<ng-katex-paragraph [paragraph]=\"latex\"></ng-katex-paragraph>"